export const milliseconds = 1
export const seconds = 1000 * milliseconds
export const minutes = 60 * seconds
export const hours = 60 * minutes
export const days = 24 * hours
export const weeks = 7 * days
